import track21 from '../../../../assets/audio/tracks/track21.mp3';

export const step21crossroads = {
    id: 20,
    title: '8. stanoviště',
    catImage: 8,
    taskText: `
        <p>
            Tak aspoň rovnou víme i ten směr. Teď už pojď pryč od toho Žďasu, vždycky je tady hrozný hluk a taky smrad, co vadí mým kočičím smyslům. 
        </p>
        <p>
            To je ale strašně divný potrubí, na který koukáme co? By mě zajímalo, od čeho asi je. Třeba to tam bude někde na konci napsaný. Hele a vidíš ty divný pilířky? Co to asi může znamenat? Koukneme se na konci.  
        </p>
    `,
    audio: track21,
    snowAudio: track21,
    continueButtonText: 'Jsme na konci',
};
